import { registerRootComponent } from 'expo'
import App from './app/routes/routes'

registerRootComponent(App)
